module.exports = __webpack_public_path__ + "static/img/a087.d2e0709.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banner/s/a087.jpg
// module id = P6cq
// module chunks = 0